import React from 'react'

export const useIsDashboardActive = (isPopupOpen: boolean): boolean => {
  const [isVisible, setIsVisible] = React.useState(
    typeof document !== 'undefined' ? document.visibilityState === 'visible' : true,
  )

  React.useEffect(() => {
    const onChange = () => setIsVisible(document.visibilityState === 'visible')
    document.addEventListener('visibilitychange', onChange)
    return () => document.removeEventListener('visibilitychange', onChange)
  }, [])

  return isVisible && !isPopupOpen
}
